import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerUserService,
  CustomerUserModel,
  CustomerUserRequest,
  CustomerUserEditRequest,
  CustomerUserListRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerUserApiService {
  constructor(private apiService: CustomerUserService) {}

  public activateCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserActivate(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addCustomerUser(customerId: string, body: CustomerUserRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserAdd(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.customerUserDelete(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCustomerUser(customerId: string, userId: string, body: CustomerUserEditRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserEdit(customerId, userId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserGet(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCustomerUsers(customerId: string, body: CustomerUserListRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel[]> {
    return this.apiService.customerUserList(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public resendCustomerUserInvitation(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserResendInvitation(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public suspendCustomerUser(customerId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerUserModel> {
    return this.apiService.customerUserSuspend(customerId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
